import { CST_LOCALSTORAGE_VALUE } from '../const';
import { JsLineDec } from '../json-interface';

export interface BackupDecInterface {
  code: any;
  orderHeader: any;
  jsonLineDec: JsLineDec[];
}

/**
 * Gere tout ce qui est backup du décorticage dans le navigateur
 */
export class BackupDec {

  /**
  * supprimer le JSSteelList du localstorage
  */
  static clearAnalysisBackup() {
    localStorage.removeItem(CST_LOCALSTORAGE_VALUE.WEB_ANALYSIS_BACKUP);
  }

  /**
   * Charge le JSSteelList depuis le localstorage & applique les info au décorticage en cours
   * @param code Utilisé pour verifier que le code de la liste d'acier correspond a celle enregustré dans les backup
   * @returns la backup du déco actuel, ou undefined si la backup n'existe pas ou correspond pas au déco
   */
  static loadAnalysisBackup(code: string): BackupDecInterface|undefined {
    try {
      const strJS = localStorage.getItem(CST_LOCALSTORAGE_VALUE.WEB_ANALYSIS_BACKUP);
      if (strJS) {
        const jsAnalysisBackup: BackupDecInterface = JSON.parse(strJS);
        if (code == jsAnalysisBackup.code) {
          return jsAnalysisBackup;
        } else {
          console.log('Unable to backup: not the same code');
        }
      } else {
        console.log('No backup found');
      }
    } catch (e) {
      console.error('Unable to get the analysis backup from the localstorage', e);
    }
    return undefined;
  }

  /**
   * Stock ou met a jour le JSSteelList du décorticage en court dans le localstorage
   * @param backupJson Sauvegarde du déco a stocker
   */
  static updateAnalysisBackup(backupJson: BackupDecInterface) {
    const strBackupJson = JSON.stringify(backupJson);
    // Recuperation du CLineDec & Info du deco en JSON
    localStorage.setItem(CST_LOCALSTORAGE_VALUE.WEB_ANALYSIS_BACKUP, strBackupJson);
  }
}
